export const parseDate = (str) => {
    let date = new Date(str);
    let day = date.toLocaleDateString();
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return `${hours}:${minutes}, ${day}`;
};
